var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 58,
    viewBox: "0 0 68 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -7)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.752,
    transform: "rotate(15 -20.075 106.458)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 50,
    fill: "#E1DCFD",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A094DF",
    d: "M18.605 5.224l-2.233-2.239-2.232 2.239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.423 37.965a1.67 1.67 0 0 1-1.668-1.673 1.67 1.67 0 0 1 1.668-1.672 1.67 1.67 0 0 1 1.668 1.672 1.67 1.67 0 0 1-1.668 1.673zm5.56-8.418v-2.05a.629.629 0 0 0-.285-.521l-1.655-1.108a.629.629 0 0 1-.284-.522v-3.908a.622.622 0 0 0-.125-.37l-.711-.95a.615.615 0 0 1 0-.74l.711-.952a.62.62 0 0 0 .125-.37v-2.891a.63.63 0 0 0-.272-.514l-1.557-1.094a.692.692 0 0 0-.79 0l-1.558 1.094a.63.63 0 0 0-.271.514v13.734a6.69 6.69 0 0 0-3.892 6.083c0 3.695 2.987 6.69 6.672 6.69 3.684 0 6.672-2.995 6.672-6.69a6.689 6.689 0 0 0-2.78-5.435z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#404042",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26.387 15.385l26.597 7.126M29.209 19.231l-9.368 34.96M42.78 17.46l-1.576-2.74-2.736 1.584"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404042",
    d: "M29.51 12.358a.746.746 0 0 1 .911-.528.746.746 0 0 1-.386 1.442.746.746 0 0 1-.526-.914M34.541 13.707a.746.746 0 0 1 .912-.529.746.746 0 0 1-.386 1.442.746.746 0 0 1-.526-.913M45.324 16.596a.746.746 0 0 1 .912-.529.746.746 0 0 1-.387 1.442.746.746 0 0 1-.525-.913M51.074 18.137a.746.746 0 0 1 .912-.529.746.746 0 0 1-.386 1.442.746.746 0 0 1-.526-.913"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#404042",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M46.255 56.248l-1.352 5.046a2.98 2.98 0 0 1-3.648 2.112l-25.159-6.74a2.98 2.98 0 0 1-2.102-3.655l11.396-42.53a2.98 2.98 0 0 1 3.647-2.112l25.16 6.741a2.98 2.98 0 0 1 2.102 3.654l-6.374 23.788"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#404042",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M31.233 48.261a1.67 1.67 0 0 1-1.178-2.047A1.67 1.67 0 0 1 32.1 45.03a1.67 1.67 0 0 1 1.179 2.047m5.504-5.507l.53-1.98a.629.629 0 0 0-.139-.578l-1.312-1.499a.629.629 0 0 1-.14-.577l1.012-3.775a.622.622 0 0 0-.024-.39l-.441-1.102a.615.615 0 0 1 .191-.715l.933-.734a.62.62 0 0 0 .216-.325l.749-2.794a.63.63 0 0 0-.13-.566l-1.22-1.46a.692.692 0 0 0-.764-.204l-1.787.653a.63.63 0 0 0-.396.426l-3.554 13.266a6.69 6.69 0 0 0-5.334 4.87c-.957 3.568 1.153 7.235 4.713 8.189m5.666-1.065a6.675 6.675 0 0 0 2.51-3.672 6.689 6.689 0 0 0-1.279-5.968"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#52C9F4",
    fillOpacity: 0.272
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.063 40.082l-12.976 1.03a.406.406 0 0 0-.34.3l-.09.334a.41.41 0 0 0 .142.432l10.679 7.524a.38.38 0 0 0 .36.047.415.415 0 0 0 .25-.28l2.382-8.88a.412.412 0 0 0-.075-.363.383.383 0 0 0-.332-.144M2.794 32.361l12.976-1.03a.406.406 0 0 0 .34-.3l.09-.334a.41.41 0 0 0-.142-.433L5.38 22.741a.38.38 0 0 0-.36-.047.415.415 0 0 0-.25.28l-2.382 8.88a.412.412 0 0 0 .075.363c.08.1.206.156.332.144"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitorIcon);
export default __webpack_public_path__ + "static/media/visitor_icon.e5e0ea4c3c41cad9cdcb313004cf5cf6.svg";
export { ForwardRef as ReactComponent };